import { PageHeader } from 'antd';

import './styles.module.less';

export default PageHeader;
